// Currency & date formatters for pt-BR
export const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });

export const fmtNumber = (v) =>
  Number(v ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('T')[0].split('-');
  return `${d}/${m}/${y}`;
};

export const fmtDateShort = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('T')[0].split('-');
  return `${d}/${m}`;
};

export const monthLabel = (year, month) => {
  const names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  return `${names[month - 1]} ${year}`;
};

export const monthShort = (ym) => {
  const [y, m] = ym.split('-');
  const names = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  return `${names[parseInt(m, 10) - 1]}/${y.slice(2)}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const roleLabel = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Administrador',
  FINANCEIRO: 'Financeiro',
  GERENTE: 'Gerente',
  OPERADOR: 'Operador',
  VISUALIZADOR: 'Visualizador',
};

export const statusLabel = {
  PENDING: 'Pendente',
  PARTIAL: 'Parcial',
  PAID: 'Pago',
  OVERDUE: 'Vencido',
  CANCELLED: 'Cancelado',
};

export const statusColor = {
  PENDING: 'bg-amber-500/10 text-amber-600 border-amber-500/30 dark:text-amber-400',
  PARTIAL: 'bg-cyan-500/10 text-cyan-600 border-cyan-500/30 dark:text-cyan-400',
  PAID: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/30 dark:text-emerald-400',
  OVERDUE: 'bg-rose-500/10 text-rose-600 border-rose-500/30 dark:text-rose-400',
  CANCELLED: 'bg-zinc-500/10 text-zinc-500 border-zinc-500/30 dark:text-zinc-400',
};

export const accountTypeLabel = {
  CAIXA: 'Caixa',
  BANCO: 'Banco',
  CORRENTE: 'Conta Corrente',
  POUPANCA: 'Poupança',
  CARTEIRA: 'Carteira',
  DIGITAL: 'Digital',
};
